import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import { parse } from "query-string"
import * as actionCreators from "../redux/action_creators"
import * as jwtUtils from "../util/jwt_utils"
import { makeToast } from "../util/toast_util"
import { appNums } from "../common/nums/app_nums"

const { MIN_PASSWORD_LENGTH } = appNums

class ResetPassword extends React.Component {
    constructor(props) {
        super(props)
        this.handleReset = this.handleReset.bind(this)

        const query = parse(props.location.search)

        this.state = {
            email: "",
            password: "",
            confirm: "",
            token: query.t,
            unset: query.unset || false,
            showPageContent: true,
        }
    }

    componentWillMount() {
        const { token, unset } = this.state
        // The password was not set during onboarding
        // fetch profile and continue to onboarding
        if (unset) {
            jwtUtils.setToken(token)
            this.props.getProfile()
            this.setState({ showPageContent: false }, () =>
                setTimeout(() => this.setState({ showPageContent: true }), 800),
            )
        }
        jwtUtils.setToken(token, "tmp-token") // save token from URL query
        const email = token ? jwtUtils.getEmail("tmp-token") : "" // get email from body of token
        this.setState({ email: email })
    }

    componentDidMount() {
        this.password && this.password.focus()
    }

    handleReset(event) {
        event.preventDefault()
        const { email, password, confirm } = this.state

        const accountMeta = { email: email, password: password }
        const validationError = this.validatePassword({
            password: password,
            confirm: confirm,
        })
        if (validationError) {
            // toast
            const ind = "danger"
            makeToast(validationError, ind)
            return
        }
        this.props
            .resetPassword(accountMeta, "login") // show success alert on login
            .then(() => this.props.signIn(accountMeta, "signIn"))
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    validatePassword(meta) {
        const emptyField = Object.keys(meta).find(key => meta[key].length === 0)
        if (emptyField) {
            return `All fields required`
        }
        return meta.password !== meta.confirm
            ? "Passwords do not match"
            : meta.confirm.length < MIN_PASSWORD_LENGTH
                ? `New password must be at least ${MIN_PASSWORD_LENGTH} characters long`
                : ""
    }

    render() {
        const { email, password, confirm, showPageContent } = this.state

        return showPageContent ? (
            <div className="container sign-in">
                <form id="signin-form">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className="center">Reset Your Password</h4>
                            <p className="center">Make it a good one!</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12 form-group">
                            {/* <label>Email</label> */}
                            <input
                                type="email"
                                disabled
                                className="form-control"
                                value={email}
                                tabIndex="1"
                            />
                        </div>
                        <div className="col-md-12 form-group">
                            <input
                                type="password"
                                placeholder="Password"
                                ref={ref => (this.password = ref)}
                                name="password"
                                className="form-control"
                                onChange={this.handleChange.bind(this)}
                                value={password}
                                tabIndex="1"
                            />
                        </div>
                        <div className="col-md-12 form-group">
                            <input
                                type="password"
                                placeholder="Confirm password"
                                name="confirm"
                                className="form-control"
                                onChange={this.handleChange.bind(this)}
                                value={confirm}
                                tabIndex="1"
                            />
                        </div>
                    </div>
                    <div className="form-actions">
                        <input
                            type="submit"
                            className="btn btn-primary btn-block btn-lg"
                            tabIndex="3"
                            value="Save New Password"
                            onClick={this.handleReset}
                        />
                    </div>
                </form>
                <div className="row">
                    <div className="col-md-12">
                        <div className="center">
                            <Link to="/signIn">Sign In</Link>
                            &nbsp; or &nbsp;
                            <Link to="/signUp">Sign Up</Link>.
                        </div>
                    </div>
                </div>
            </div>
        ) : (
            <div />
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(ResetPassword)



// WEBPACK FOOTER //
// ./src/pages/reset_password.jsx